/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {AnimaFadeinTop} from '../../../../_metronic/assets/animation/styles'
import {IndemnityAreaListWrapper} from './components/indemnityItems-list/IndemnityAreaList'
import {QueryRequestProvider} from './components/indemnityItems-list/core/QueryRequestProvider'
import {QueryResponseProvider} from './components/indemnityItems-list/core/QueryResponseProvider'
import {ListViewProvider} from './components/indemnityItems-list/core/ListViewProvider'

const IndemnityItemPage: FC = () => {
  return (
    <>
      <AnimaFadeinTop>
        <QueryRequestProvider>
          <QueryResponseProvider>
            <ListViewProvider>
              <IndemnityAreaListWrapper />
            </ListViewProvider>
          </QueryResponseProvider>
        </QueryRequestProvider>
      </AnimaFadeinTop>
    </>
  )
}

export {IndemnityItemPage}
